import React from 'react';
import axios from 'axios';
import 'react-table/react-table.css';
import Pagination from 'react-js-pagination';
import { LinearProgress } from 'react-md';
import { MenuItem, Dropdown } from 'react-bootstrap';
import '../../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import Loader from '../../_components/loader';
import 'react-notifications/lib/notifications.css';
import { AdminUrls } from '../../network/config';
import './style.css';
import { connect } from 'react-redux';
import { removeData } from '../../store/action';
const moment = require('moment');
const recordZero_Url = AdminUrls.ADMIN.RECORDEDZEROHOUR;
const cpdDownloadExcel = AdminUrls.ADMIN.RECORDEDZEROHOUREXCEL;

class RecordedZeroHour extends React.Component {
  constructor() {
    super();
    this.handlePageChange = this.handlePageChange.bind(this);
    this.clearSearchFilters = this.clearSearchFilters.bind(this);
    this.downloadExcel = this.downloadExcel.bind(this);
    this.getCpdRecordZero = this.getCpdRecordZero.bind(this);
    this.searchData = this.searchData.bind(this);
    this.pageChange = this.pageChange.bind(this);

    this.state = {
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 0,
      unauthorized: false,
      cpdId: '',
      cpdBool: '',
      cpdMemberNum: '',
      cpdEmail: '',
      cpdUsername: '',
      cpdYear: '',
      loadZeroRecord: [],
      mainLoading: false,
      emptyDivMsg: 'There is no data to show in the grid.',
      sort: {
        column: 'MemberNumber',
        direction: 'desc',
      },
      yearCpd: '',
      queryType: '',
      selectYear: '',
    };
    this.controller = new AbortController();
  }
  pageChange(pageQty) {
    this.setState({
      per_page: pageQty,
    });
    setTimeout(() => {
      this.getCpdRecordZero(this.state.activePage, this.state.queryType);
    }, 1000);
  }

  downloadExcel(year) {
    let dat = new Date();
    let newd = dat.getTime();

    var fileType = 'application/vnd.ms-excel';
    var name;
    this.setState({ mainLoading: true });
    axios(cpdDownloadExcel, {
      params: {
        reportId: this?.state?.cpdId,
        year: year,
      },
      responseType: 'blob',
      method: 'GET',
      signal: this.controller.signal,
      withCredentials: true,
      credentials: 'include',
      headers: {
        Authorization:
          `${this.props.user.token_type} ` + this.props.user.access_token,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        var blob = new Blob([response.data], { type: fileType });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `NotEngagedReport2021${newd}.xlsx`);
          document.body.appendChild(link);
          link.click();
        }
      })
      .then((data) => {
        this.setState({ mainLoading: false });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handlePageChange(pageNumber) {
    this.setState({
      activePage: pageNumber,
    });
    this.getCpdRecordZero(pageNumber, this.state.queryType);
  }

  componentDidMount() {
    let id = this.props.match.params.recordId;
    if (id === 'CPD0006') {
      this.setState(
        {
          queryType: 1,
          cpdId: id,
        },
        this.getCpdRecordZero(1, 1)
      );
    }
    if (id === 'CPD0007' || id === 'CPD0008') {
      this.setState(
        {
          queryType: 2,
          cpdId: id,
        },
        this.getCpdRecordZero(1, 2)
      );
    }
  }

  clearSearchFilters() {
    this.setState(
      {
        totalPages: 0,
        totalCount: 0,
        per_page: 10,
        activePage: 0,
        unauthorized: false,
        cpdMemberNum: '',
        selectYear: '',
      },
      () => {
        this.getCpdRecordZero(1, this.state.queryType);
      }
    );
  }

  getCpdRecordZero(active, query, column, direction) {
    let reverse = this.state.sort.direction;
    let sortBy = this.state.sort.column;
    this.setState({
      mainLoading: true,
    });
    if (column) {
      sortBy = column;
    }

    if (direction) {
      reverse = direction;
    }
    reverse = reverse === 'asc' ? false : true;

    axios
      .get(recordZero_Url, {
        params: {
          QueryType: query,
          page: active,
          pageSize: this.state.per_page,
          reverse: reverse,
          sortBy: sortBy,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          loadZeroRecord: response?.data?.Items,
          activePage: response?.data?.Page,
          totalCount: response?.data?.TotalCount,
          totalPages: response?.data?.TotalPages,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  searchData() {
    let pages = this.state.activePage;
    let memberNumbers = this.state.cpdMemberNum;
    let selectyear = this.state.selectYear;
    let reverse = this.state.sort.direction;

    this.setState({
      mainLoading: true,
    });

    reverse = reverse === 'asc' ? false : true;
    let obj = {
      QueryType: this?.state?.queryType,
      page: pages,
      pageSize: this.state.per_page,
      reverse: reverse,
      sortBy: this?.state?.sort?.column,
    };

    if (selectyear) {
      obj.Year = selectyear;
    }

    if (memberNumbers) {
      obj.MemberNumber = memberNumbers;
    }

    axios
      .get(recordZero_Url, {
        params: obj,
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          loadZeroRecord: response?.data?.Items,
          activePage: response?.data?.Page,
          totalCount: response?.data?.TotalCount,
          totalPages: response?.data?.TotalPages,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === 'asc'
        ? 'desc'
        : 'asc'
      : 'desc';
    this.setState({
      sort: {
        column,
        direction,
      },
    });
    this.getCpdRecordZero(
      this.state.activePage,
      this?.state?.queryType,
      column,
      direction
    );
  };

  setArrow = (column) => {
    let className = 'fa fa-sort';
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === 'asc' ? '-asc' : '-desc';
    }
    return className;
  };

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let loadZeroRecord;

    if (this.state?.loadZeroRecord !== null) {
      loadZeroRecord = this.state?.loadZeroRecord?.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item?.MemberNumber}</td>
            <td>{item?.UserName}</td>
            <td>{item?.Email ? item?.Email : 'na'}</td>

            <td>
              {item?.LastLoginTime
                ? moment(item?.LastLoginTime).format('ll')
                : 'na'}
            </td>
            <td>{item?.Status}</td>

            <td>
              {item?.DateOfTermination
                ? moment(item?.DateOfTermination).format('ll')
                : 'na'}
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div>
          <div className="panel panel-default">
            <div className="panel-heading-cpd-3" style={{ padding: '10px' }}>
              <i
                className="fa fa-filter "
                title=""
                data-original-title="Search"
              >
                {' '}
                Search
              </i>
            </div>
            <div className="shadow">
              <div className="layout-gt-sm-row">
                <div style={{ padding: '1rem 1rem' }}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Memebership number</label>

                        <input
                          type="memebership number"
                          className="form-control"
                          id="memebership number"
                          value={this.state.cpdMemberNum}
                          onChange={(e) =>
                            this.setState({ cpdMemberNum: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Year</label>
                        <select
                          className="form-control"
                          value={this.state.selectYear}
                          onChange={(e) =>
                            this.setState({ selectYear: e.target.value })
                          }
                          id="sel1"
                        >
                          <option value="" selected disabled hidden></option>

                          <option value={'2023'}>2023</option>
                          <option value={'2024'}>2024</option>
                          <option value={'2025'}>2025</option>
                          <option value={'2026'}>2026</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      style={{ marginRight: '10px' }}
                      onClick={this.searchData}
                    >
                      <span className="glyphicon glyphicon-search"> </span>{' '}
                      Search
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={this.clearSearchFilters}
                    >
                      <span className="glyphicon glyphicon-remove-sign"> </span>{' '}
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="gridTopButtons">
              <button
                type="button"
                onClick={() => window.print()}
                className="btn btn-danger btn-circle btn-lg "
              >
                <i className="fa fa-print"> </i>
              </button>

              <Dropdown id="dropdown-custom-1">
                <Dropdown.Toggle
                  className="btn btn-success btn-circle btn-lg"
                  style={{ marginLeft: '10px' }}
                  noCaret
                >
                  <i className="fa fa-file-pdf-o"> </i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel('All');
                    }}
                    eventKey="4"
                  >
                    All
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2023);
                    }}
                    eventKey="4"
                  >
                    2023
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2024);
                    }}
                    eventKey="5"
                  >
                    2024
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2025);
                    }}
                    eventKey="6"
                  >
                    2025
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2026);
                    }}
                    eventKey="7"
                  >
                    2026
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <div className="col-md-6">
            <div className="gridTopDropdown">
              Show{' '}
              <select
                className="input-sm"
                aria-invalid="false"
                onChange={(e) => this.pageChange(e.target.value)}
              >
                <option label="10" value="10" selected="selected">
                  10
                </option>
                <option label="20" value="20">
                  20
                </option>
                <option label="30" value="30">
                  30
                </option>
              </select>{' '}
              entries
            </div>
          </div>
        </div>
        <div className="col-table">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr className="header">
                <th onClick={this.onSort('MemberNumber')}>
                  Member Number{' '}
                  <i className={this.setArrow('MemberNumber')}> </i>
                </th>
                <th onClick={this.onSort('UserName')}>
                  User <i className={this.setArrow('UserName')}> </i>
                </th>
                <th onClick={this.onSort('Email')}>
                  Email <i className={this.setArrow('Email')}> </i>
                </th>
                <th onClick={this.onSort('LastLoginTime')}>
                  LastLoginTime{' '}
                  <i className={this.setArrow('LastLoginTime')}> </i>
                </th>
                <th onClick={this.onSort('Status')}>
                  Status <i className={this.setArrow('Status')}> </i>
                </th>
                <th onClick={this.onSort('DateOfTermination')}>
                  DateOfTermination{' '}
                  <i className={this.setArrow('DateOfTermination')}> </i>
                </th>
              </tr>
            </thead>
            <tbody>{loadZeroRecord}</tbody>
          </table>
          {loadZeroRecord?.length > 0 ? '' : this.state.emptyDivMsg}
        </div>
        <div>
          <Pagination
            prevPageText="Previous"
            nextPageText="Next"
            activePage={this.state.activePage}
            itemsCountPerPage={this.state.per_page}
            totalItemsCount={this.state.totalCount}
            onChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RecordedZeroHour);
